import React from "react";
import Typography from "@material-ui/core/Typography";

const PartnersContactList = ({ budgets, classes }) => {
    if (!budgets || !budgets.length) return null;

    const partners = [];
    const seen = new Set();
    budgets.forEach(b => {
        if (!b.partnership || seen.has(b.partnership)) return;
        seen.add(b.partnership);
        partners.push(b);
    });

    if (!partners.length) return null;

    return (
        <>
            <Typography variant="h3" className={classes.gutterTop} gutterBottom>
                Partners Contact
            </Typography>
            {partners.map(p => (
                <Typography key={p.partnership} variant="body1" gutterBottom>
                    <b>{p.partnership}:</b>&nbsp;
                    {p.contact_name || "No contact name"} &ndash; {p.contact_email || "No contact email"} &ndash; {p.contact_phone || "No contact phone"}
                </Typography>
            ))}
        </>
    );
};

export default PartnersContactList;
